import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as analytics from '../../utils/analytics';

/*
Analytics Component
-------------------
Tracks page views on route changes
*/

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    analytics.pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

export default Analytics;
